export const enDeals = {
  OpenAuction: 'Open Auction',
  PrivateAuction: 'Private Auction',
  ProgrammaticGuaranteed: 'Programmatic Guaranteed',
  PreferredDeal: 'Preferred Deal',
  SeatID: 'Seat ID',
};